import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import { Accordion } from '@hub/accordion';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackEvent from '../../../helpers/analytics-utils/track-event';
import { PaneAccordion } from '../pane-accordion';
import { LinkContext } from './context';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const attrsAllowList = ['target', 'rel', 'title'];

const Pane = ({
  depth = 0,
  title,
  items,
  initialPath,
  onClose,
  onExit
}) => {
  const Link = useContext(LinkContext);
  const {
    0: path,
    1: setPath
  } = useState(initialPath);
  const {
    0: expandedIndex,
    1: setExpandedIndex
  } = useState();
  useEffect(() => setPath(initialPath), [initialPath]); // to get the default accordion index (this will be use on mobile)

  let accordionIndex = [0]; // count the number of items that does not use accordion

  const noItemCnt = items.filter(item => (item === null || item === void 0 ? void 0 : item.items) === undefined).length;

  if (initialPath && depth === 1) {
    accordionIndex = [initialPath[0] - noItemCnt];
  } // to scroll pane to the top based on the expanded index


  const latestAccordion = useRef(null);
  useEffect(() => {
    var _el$lastElementChild$, _el$lastElementChild, _el$lastElementChild$2, _el$lastElementChild$3, _el$lastElementChild2, _el$lastElementChild3, _el$lastElementChild4;

    const el = latestAccordion.current;

    if (!el) {
      return;
    } // to check if the div is already visible then it will anchor on that element to avoid scrolling


    const height1 = (_el$lastElementChild$ = (_el$lastElementChild = el.lastElementChild) === null || _el$lastElementChild === void 0 ? void 0 : (_el$lastElementChild$2 = _el$lastElementChild.lastElementChild) === null || _el$lastElementChild$2 === void 0 ? void 0 : _el$lastElementChild$2.clientHeight) !== null && _el$lastElementChild$ !== void 0 ? _el$lastElementChild$ : 0;
    const height2 = (_el$lastElementChild$3 = (_el$lastElementChild2 = el.lastElementChild) === null || _el$lastElementChild2 === void 0 ? void 0 : (_el$lastElementChild3 = _el$lastElementChild2.lastElementChild) === null || _el$lastElementChild3 === void 0 ? void 0 : (_el$lastElementChild4 = _el$lastElementChild3.lastElementChild) === null || _el$lastElementChild4 === void 0 ? void 0 : _el$lastElementChild4.clientHeight) !== null && _el$lastElementChild$3 !== void 0 ? _el$lastElementChild$3 : 0;

    if (height1 > 0 && height2 > 0 && height1 === height2) {
      // track event for mobile automatic scroll pane
      trackAccordionPane(accordionIndex[0]);
      return;
    }

    setExpandedIndex(accordionIndex);
  });
  useEffect(() => {
    var _latestAccordion$curr;

    (_latestAccordion$curr = latestAccordion.current) === null || _latestAccordion$curr === void 0 ? void 0 : _latestAccordion$curr.scrollIntoView();
  }, [expandedIndex]); // this is used to track event for accordion pane

  const trackAccordionPane = index => {
    items.forEach((item, i) => {
      if (item) {
        if ('items' in item && i - noItemCnt === index && depth === 1) {
          trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, "L1-".concat(i, " ").concat(item.title));
        }
      }
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classNames(style.pane),
      "data-test-id": "main-navdrawer-".concat(depth),
      children: [title && /*#__PURE__*/_jsx("div", {
        className: classNames(style.title),
        children: title
      }), /*#__PURE__*/_jsx(Accordion, {
        allowToggle: true,
        defaultIndex: accordionIndex,
        onChange: index => {
          trackAccordionPane(index);
        },
        children: items.map((item, i) => {
          if (!item) {
            return null;
          }

          if ('url' in item) {
            const attrs = item.attrs;
            return /*#__PURE__*/_createElement(Link, _objectSpread(_objectSpread({}, attrs && attrsAllowList.reduce((memo, key) => _objectSpread(_objectSpread({}, memo), {}, {
              [key]: attrs[key]
            }), {})), {}, {
              key: i,
              to: item.url,
              className: classNames(item.className, style.link, style.item, depth === 1 && 'key' in item ? style.linkBold : null),
              "data-test-id": "main-navdrawer-link-".concat(depth, "-").concat(i),
              onClick: () => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "L".concat(depth, "-").concat(i, " ").concat(item.label));
              }
            }), item.label);
          }

          if ('items' in item) {
            // third level pane accordion
            if (depth === 1) {
              return /*#__PURE__*/_jsx("div", {
                className: classNames(style['accordion-scroll-mobile']),
                ref: i === (path === null || path === void 0 ? void 0 : path[0]) ? latestAccordion : null,
                children: /*#__PURE__*/_jsx(PaneAccordion, {
                  itemCnt: i,
                  itemTitle: item.title,
                  items: item.items
                })
              }, i);
            }

            const children = /*#__PURE__*/_jsxs(_Fragment, {
              children: [item.title, /*#__PURE__*/_jsx(Icon, {
                size: "small",
                type: "chevron-right",
                className: classNames(style.chevron, style.icon),
                "data-test-id": "main-navdrawer-expand-icon"
              })]
            });

            return i === (path === null || path === void 0 ? void 0 : path[0]) ? /*#__PURE__*/_jsx("div", {
              className: classNames(item.className, style.item, style.active),
              children: children
            }, i) : /*#__PURE__*/_jsx("button", {
              className: classNames(item.className, style.item, style.link),
              "data-test-id": "main-navdrawer-button-".concat(depth, "-").concat(i),
              onClick: () => {
                setPath([i]);
                trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_OPEN, "L".concat(depth, "-").concat(i, " ").concat(item.title));
              },
              children: children
            }, i);
          }

          const x = {
            render: item
          };
          return /*#__PURE__*/_jsx(x.render, {}, i);
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(style['header-pane-mobile']),
        children: [onClose && /*#__PURE__*/_jsx("button", {
          className: classNames(style.link, style.arrow),
          onClick: onClose,
          children: /*#__PURE__*/_jsx(Icon, {
            size: "medium",
            type: "arrow-left",
            className: classNames(style['action-icon'])
          })
        }), onExit && /*#__PURE__*/_jsx("button", {
          className: classNames(style.link, style.cross),
          "aria-label": "Close Navigation",
          "data-test-id": "main-navdrawer-close",
          onClick: onExit,
          children: /*#__PURE__*/_jsx(Icon, {
            size: "small",
            type: "cross",
            className: classNames(style['action-icon'])
          })
        })]
      })]
    }), (() => {
      if (path !== null && path !== void 0 && path.length) {
        const i = path[0];
        const item = items[i];

        if (item && 'items' in item) {
          // added this condition for third level pane accordion
          if (depth !== 1) {
            return /*#__PURE__*/_jsx(Pane, {
              depth: depth + 1,
              title: item.hideTitle ? undefined : item.title,
              items: item.items,
              initialPath: path === null || path === void 0 ? void 0 : path.slice(1),
              onClose: () => {
                setPath([]);
                trackEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_MENU_CLOSE, "L".concat(depth, "-").concat(i, " ").concat(item.title));
              },
              onExit: onExit
            }, i);
          }
        }
      }

      return null;
    })()]
  });
};

export default Pane;